import { render, staticRenderFns } from "./paper-share-with-user-popup.html?vue&type=template&id=5b566458&scoped=true&"
import script from "./paper-share-with-user-popup.js?vue&type=script&lang=js&"
export * from "./paper-share-with-user-popup.js?vue&type=script&lang=js&"
import style0 from "./paper-share-with-user-popup.scss?vue&type=style&index=0&id=5b566458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b566458",
  null
  
)

export default component.exports